export default "__VITE_ASSET__BpDdI4iR__"